import { EventBus, Events } from "jiffy-store";
import { track } from "jiffy-analytics";
import { observeElementVisibility, isScrollOnTop } from "common/utils/ui/visibility";
import { isCustomizableMadePage } from "components/jiffy/product-details/customizable-made-page-utils";
import initDates from "./init-dates";
import initMadeDates from "./init-made-dates";
import initForm from "./init-form";
import { DtfPricesDecorator } from "./init-dtf-prices";
import selectors from "./selectors";

import "./product-details-delivery-date-simple.scss";

const $getContainer = () => document.getElementById(selectors.local.CONTAINER);
const $getMadeContainer = () => document.getElementById(selectors.made.CONTAINER);

const initFormWithDynamicData = () => {
  const addressExists = document.pdpDynamicData.isAddressExists;
  const zipCode = document.pdpDynamicData.zipcode;
  if (!addressExists && !zipCode) {
    initForm();
  }
};

export default async (isMade = false) => {
  const $container = $getContainer() || $getMadeContainer();
  if (!$container) return;

  let dtfPricesDecorator;
  if ($container.dataset.enabledShippingEnhancementServices === "true") {
    dtfPricesDecorator = new DtfPricesDecorator();
    dtfPricesDecorator.subscribe();
  }

  if (!isCustomizableMadePage()) {
    initDates({ dtfPricesDecorator });
  }

  if ($getMadeContainer() || isMade) {
    initMadeDates();
  }

  if (window.dynamicDataLoaded) {
    initFormWithDynamicData();
  } else {
    document.addEventListener("dynamicDataLoaded", initFormWithDynamicData, false);
  }

  if (isScrollOnTop()) {
    observeElementVisibility(
      $getContainer(),
      (entries, scrolled) => {
        track("viewed_on_pdp", { target: "delivery_date", scrolled });
      },
      { mobileOnly: true, once: true }
    );
  }

  // manage component visibility according to the `showEstimates` composition state
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (_evt, { showEstimates }) => {
    $container.classList.toggle("hidden", showEstimates === "false");
  });
};
